export const customerAddFormDefaultValues = {
    name: '',
    street: '',
    countryCode: '',
    postCode: null,
    city: '',
    customerName: '',
    customers: [],
};
